import { QueryClient } from '@tanstack/react-query'

export function getContext() {
  const queryClient = new QueryClient({
    defaultOptions: { queries: {
      // Permission/not-found errors need action, not repeated waiting.
      retry: (count, error) => count < 1 && !('status' in error && Number(error.status) >= 400 && Number(error.status) < 500),
      retryDelay: 1000,
    } },
  })

  return {
    queryClient,
  }
}
export default function TanstackQueryProvider() {}
